export default __webpack_public_path__ + "static/media/276.8d877a48.png";